// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"33":"6797b41e76b06a11","101":"5f0ce8ca53f8dd57"}[chunkId] + ".css";
};